<template>
  <v-content class="fill-height">
    <v-container
      class="fill-height"
      fluid
    >
      <v-row class="d-flex justify-center align-center fill-height">
        <v-col
          cols="12"
          sm="8"
          md="4"
        >
          <v-form @submit.prevent="submit">
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Login</v-toolbar-title>
                <div class="flex-grow-1" />
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  v-model="username"
                  label="Username"
                  name="username"
                  type="text"
                />

                <v-text-field
                  v-model="password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  name="password"
                  label="Password"
                  @click:append="showPassword = !showPassword"
                />

                <div>
                  <p
                    v-if="errors"
                    class="red--text text--lighten-1"
                  >
                    incorrect credentials
                  </p>
                </div>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1" />
                <v-btn
                  color="primary"
                  type="submit"
                >
                  Login
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import apiUtil from '../utils/ApiUtil';

export default {
  data: () => {
    return {
      errors: false,
      username: null,
      password: null,
      showPassword: false,
    };
  },
  created() {
    if (this.$store.state.hasAccess) {
      this.$router.push({ path: '/' });
    }
  },
  methods: {
    async submit() {
      this.errors = false;
      if (!this.username || !this.password) {
        this.errors = true;
        return;
      }
      const result = await apiUtil.login(this.username, this.password);
      if (Object.keys(result).length <= 0) {
        this.errors = true;
        return;
      }
      this.$store.dispatch('setUser', result);
      if (this.$store.state.user.preferences) {
        if (this.$store.state.user.preferences.darkTheme) {
          this.$vuetify.theme.dark = this.$store.state.user.preferences.darkTheme;
        }
        if (this.$store.state.user.preferences.language) {
          this.$vuetify.lang.current = this.$store.state.user.preferences.language;
        }
      }
      this.$store.dispatch('setAccess', true);
      this.$router.push({ path: '/' });
    },
  },
};
</script>
